const openModal = (state, action) => {
  const shouldDisplaySingleModal = state.activeModal && state.disallowMultipleModals;
  const isOpenedModal = state.openModals.includes(action.modalType);
  if (shouldDisplaySingleModal || isOpenedModal) {
    return state;
  }
  return Object.assign({}, state, {
    activeModal: action.modalType,
    openModals: [action.modalType, ...state.openModals],
    additionalData: Object.assign({}, state.additionalData, action.additionalData),
  });
};

const closeModal = (state, action) => {
  const indexOfRemoval = state.openModals.indexOf(action.modalType);
  if (!state.activeModal || indexOfRemoval === -1) {
    return state;
  }

  const newOpenModals = [
    ...state.openModals.slice(0, indexOfRemoval),
    ...state.openModals.slice(indexOfRemoval + 1),
  ];
  return Object.assign({}, state, {
    activeModal: newOpenModals[0] || null,
    openModals: newOpenModals,
    finalStep: null,
  });
};

const ModalHandler = (state, action) => {
  if (typeof state === 'undefined') {
    return {
      activeModal: null,
      openModals: [],
      disallowMultipleModals: false,
      additionalData: {},
      finalStep: null,
    };
  }

  switch (action.type) {
    case 'OPEN_MODAL':
      return openModal(state, action);
    case 'CLOSE_MODAL':
      return closeModal(state, action);
    case 'FINISH_MODAL':
      return Object.assign({}, state, { finalStep: action.data });
    default:
      return state;
  }
};

export default ModalHandler;



// WEBPACK FOOTER //
// ./src-react/Modals/ModalReducer.jsx